import styled, { css } from "styled-components/";
const Media = {
  Nav: "@media(max-width:1000px)",
  PhoneLarge: "@media(max-width:600px)",
};
export const HeaderContainer = styled.header`
  position: fixed;
  z-index: 99;
  width: 100%;
  top: 0rem;
  .header {
    position: absolute;
    width: 100%;
    z-index: 1;
    .logoSide {
      ${({ isanimation }) => isanimation && css``}
    }

    ul {
      list-style-type: none; /* Remove os marcadores padrão */
      padding-left: 0; /* Remove o recuo à esquerda padrão */
    }

    ul,
    li {
      text-decoration: none;
    }
    .logoSide {
      cursor: pointer;
          ${Media.Nav} {
        width: 90%;
      }

    }

    ul,
    li,
    a {
      list-style: none;
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 6rem;
      width: 90%;
      max-width: 90rem;
      border-radius: 0px 0px 23px 23px;
      padding: 1rem 5%;
      margin: auto;
      ${({ isanimation }) =>
    isanimation &&
    css`
          margin: auto;
          background-color: var(--light);
        `}
      ${Media.Nav} {
        width: 90%;
        margin: auto;
        background-color: var(--light);
        padding: 0 1rem;
        border-radius: 20px;
      }

      .menu {
        display: none;
        ${Media.Nav} {
          display: block;
          width: 3em;
          height: 3em;
          color: var(--blue);
          opacity: 1;
          transition: all 0.5s linear 0.1s;
          ${({ isVisible }) =>
    isVisible &&
    css`
              opacity: 0;
              transition: all 0.5s linear 0.1s;
            `}

          ${({ isanimation }) =>
    isanimation &&
    css`
              color: #000;
            `}
        }
      }
      .closeMenu {
        position: absolute;
        opacity: 0;
        z-index: -1;
        right: 5%;
        transition: all 0.1s linear;

        ${Media.Nav} {
          ${({ isVisible }) =>
    isVisible &&
    css`
              z-index: 0;
              opacity: 1;
            `}
        }
      }
      .menuSide {
        ${Media.Nav} {
          width: 100%;
          height: 100vh;
          margin-left: 100%;
          padding: 0 45px 136px 0px;
          position: absolute;
          top: -136px;
          bottom: 34px;
          z-index: -2;
          align-items: flex-end;
          flex-direction: column;
          backdrop-filter: blur(25px);
          background: rgb(0 0 0 / 40%);

          ${({ isVisible }) =>
    isVisible &&
    css`
              transition: margin-left 0.8s cubic-bezier(0.65, 0.05, 0.36, 1);
              opacity: 1;
              margin-left: 1px;
              left: -42px;
            `}
        }
        gap: 2rem;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .Options {
          color: var(--blue);
          font-family: Lato;
          font-size: 22px;
          font-weight: 400;
          position: relative;
          text-align: right;
          text-transform: uppercase;
          ${Media.Nav} {
            text-transform: none;
          }

          &:last-child {
            padding: 1rem;
            color: var(--light);
            background-color: #38af7e;
            border-radius: 20px;

            ${Media.Nav} {
              background-color: transparent;
              border-radius: 0;
              padding: 0;
              color: var(--light);
            }

             &:hover {
            transition: all 0.2s linear;
            color: var(--light);
          }
          }
          ${({ isanimation }) =>
    isanimation &&
    css`
              &:after {
                content: "";
                position: absolute;
                width: 100%;
                height: 0.5rem;
                top: 1.2rem;
                left: 0;
                z-index: -1;
                ${Media.Nav} {
                  display: none;
                }
              }
            `}
          &:hover {
            transition: all 0.2s linear;
            color: var(--blue);
          }

          ${Media.Nav} {
            font-size: 2rem;
            font-weight: bold;
            color: var(--light);
          }
        }
      }
    }
  }
`;
